import { DASH_IMG_AGRI, DASH_IMG_COORDINATOR, DASH_IMG_DEALER, DASH_IMG_FARMER, DASH_IMG_SP, OTHER_IMAGE, CUSTOMER_ICON_IMG, BDB_ICON_IMG, SP_ICON_IMG, SE_ICON_IMG, IC_ICON_IMG, D_ICON_IMG, ARCHITECT_ICON_IMG, BD_ICON_IMG } from "./image-url-constants";

export const COMPANY_FIRST_NAME = "PillarX";
export const COMPANY_NAME = "Ghorenabia Buildtech LLP";
export const DOMAIN_NAME = "pillarx.co.in";
export const POWERED_BY = `${COMPANY_FIRST_NAME} a brand of ${COMPANY_NAME}`;
export const COMPANY_ADDRESS = "No.253/6 & 7, Vasanthapura main Road, Near BRV school, Bangalore 560078";
export const COMPANY_PHONE = "+91 9513600800";
export const COMPANY_EMAIL = "support@pillarx.co.in";
export const COMPANY_INFO_EMAIL = "info@pillarx.co.in";
export const COMPANY_NEWSLETTER_EMAIL = "newsletter@pillarx.co.in";
export const COMPANY_FEEDBACK_EMAIL = "feedback@pillarx.co.in";
export const ADSERVER_ID = process.env.REACT_APP_ADSERVER_ID;
export const APP_ENV = process.env.REACT_APP_ENV;

export const DEFAULT_COUNTRY_CODE = '91';
export const DEFAULT_COUNTRY_CODE_WITH_PLUS = '+' + DEFAULT_COUNTRY_CODE;

export const BANK_SERVICE_CATEGORY_ID = 340;
export const INSURANCE_SERVICE_CATEGORY_ID = 360;
export const PROPERTY_CATEGORY_ID = 113;
export const MACHINERY_CATEGORY_ID = 1;
export const INVESTOR_CATEGORY_ID = "-3";
export const AGRI_EXPERT_CATEGORY_ID = "-4";

export const ACCESS_TYPES = {
  1: "service-provider",
  2: "business-developer",
  3: "customer",
  4: "dealer",
  5: "investor"
}

export const ACCESS_TYPES_CODE = {
  "service-provider": 1,
  "business-developer": 2,
  "customer": 3,
  "dealer": 4,
  "investor": 5
};

export const ACCESS_TYPES2 = {
  1: "SERVICE_PROVIDER",
  2: "BUSINESS_DEVELOPER",
  3: "CUSTOMER",
  4: "DEALER",
  5: "INVESTOR"
}

export const ACCESS_TYPES_NAMES = {
  "Service Provider": ACCESS_TYPES[1],
  "Business Developer": ACCESS_TYPES[2],
  "Coordinator": ACCESS_TYPES[2],
  "Customer": ACCESS_TYPES[3],
  "Dealer": ACCESS_TYPES[4],
  "Investor": ACCESS_TYPES[5]
}

export const AccessTypeConstants = {
  "SERVICE_PROVIDER": ACCESS_TYPES[1],
  "Business Developer": ACCESS_TYPES[2],
  "Customer": ACCESS_TYPES[3],
  "DEALER": ACCESS_TYPES[4],
  "INVESTOR": ACCESS_TYPES[5]
}

export const AccessTypeConstants2 = {
  "SERVICE_PROVIDER": ACCESS_TYPES2[1],
  "BUSINESS_DEVELOPER": ACCESS_TYPES2[2],
  "CUSTOMER": ACCESS_TYPES2[3],
  "DEALER": ACCESS_TYPES2[4],
  "INVESTOR": ACCESS_TYPES2[5],
}

export const AccessTypeOrder = [
  "access.customer",
  "access.dealer",
  "access.service_provider",
  "access.business_developer",
  "access.investor",
  "access.architect",
  "access.structural_engineer",
  "access.building_contractor",
  "access.interior_consultant"
];

export const accessDetailsMap = [
  {
    "id": 3,
    "name": "Customer",
    "displayCode": "access.customer",
    "active": true,
    "label": "access.customer",
    "displayName": "Customer",
    "icon": CUSTOMER_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.customer.description",
    "link": ""
  },
  {
    "label": "access.architect",
    "displayName": "Architect",
    "icon": ARCHITECT_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.architect.description",
    "link": ""
  },
  {
    "label": "access.structural_engineer",
    "displayName": "Structural Engineer",
    "icon": SE_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.structural_engineer.description",
    "link": ""
  },
  {
    "label": "access.interior_consultant",
    "displayName": "Interior Consultant",
    "icon": IC_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.interior_consultant.description",
    "link": ""
  },
  {
    "label": "access.interior_consultant",
    "displayName": "Builder & Developer",
    "icon": BD_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.interior_consultant.description",
    "link": ""
  },
  {
    "id": 4,
    "name": "Dealer",
    "displayCode": "access.dealer",
    "active": true,
    "label": "access.dealer",
    "displayName": "Dealer",
    "icon": D_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.dealer.description",
    "link": ""
  },
  {
    "id": 1,
    "name": "Service Professionals",
    "displayCode": "access.service_provider",
    "active": true,
    "label": "access.service_provider",
    "displayName": "Service Provider",
    "icon": SP_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.service_provider.description",
    "link": ""
  },
  {
    "id": 2,
    "name": "Business Developer",
    "displayCode": "access.business_developer",
    "active": true,
    "label": "access.business_developer",
    "displayName": "Business Developer",
    "icon": BDB_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.business_developer.description",
    "link": ""
  },
  {
    "id": 5,
    "name": "Investor",
    "displayCode": "access.investor",
    "active": true,
    "label": "access.investor",
    "displayName": "Investor",
    "icon": BDB_ICON_IMG,
    "title": "label.i_am_access_name",
    "subtitle": "access.investor.description",
    "link": ""
  }

];

export const accessTypeDetailsMap = {
  "access.customer": {
    label: "access.customer",
    displayName: "Customer",
    icon: CUSTOMER_ICON_IMG,
    title: "label.i_am_access_name",
    subtitle: "access.customer.description",
    link: "",
    categoryId: "-1"
  },
  "access.dealer": {
    label: "access.dealer",
    displayName: "Dealer",
    icon: DASH_IMG_DEALER,
    title: "label.i_am_access_name",
    subtitle: "access.dealer.description",
    link: ""
  },
  "access.service_provider": {
    label: "access.service_provider",
    displayName: "Service Provider",
    icon: DASH_IMG_SP,
    title: "label.i_am_access_name",
    subtitle: "access.service_provider.description",
    link: ""
  },
  "access.business_developer": {
    label: "access.business_developer",
    displayName: "Business Developer",
    icon: DASH_IMG_COORDINATOR,
    title: "label.i_am_access_name",
    subtitle: "access.business_developer.description",
    link: "",
    categoryId: "-2"
  },
  "access.investor": {
    label: "access.investor",
    displayName: "Investor",
    icon: DASH_IMG_COORDINATOR,
    title: "label.i_am_access_name",
    subtitle: "access.investor.description",
    link: "",
    categoryId: INVESTOR_CATEGORY_ID
  },
  "access.architect": {
    label: "access.architect",
    displayName: "Architect",
    icon: DASH_IMG_AGRI,
    title: "label.i_am_access_name",
    subtitle: "access.architect.description",
    link: ""
  },
  "access.structural_engineer": {
    label: "access.structural_engineer",
    displayName: "Structural Engineer",
    icon: OTHER_IMAGE,
    title: "label.i_am_access_name",
    subtitle: "access.structural_engineer.description",
    link: ""
  },
  "access.interior_consultant": {
    label: "access.interior_consultant",
    displayName: "Interior Consultant",
    icon: OTHER_IMAGE,
    title: "label.i_am_access_name",
    subtitle: "access.interior_consultant.description",
    link: ""
  },
  "access.building_contractor": {
    label: "access.building_contractor",
    displayName: "Building Contractor",
    icon: OTHER_IMAGE,
    title: "label.i_am_access_name",
    subtitle: "access.building_contractor.description",
    link: ""
  }
};

export const LISTING_STATUS = {
  "approved": "APPROVED",
  "pending": "PENDING_FOR_APPROVAL",
  "sold-out": "SOLD_OUT",
  "rejected": "REJECTED_TO_RESUBMIT",
  "refund": "REJECT_AND_REFUND",
  "in-active": "INACTIVE",
  "verfied": "VERIFIED"
};

export const machineryTraderTyreConditionList = [
  { "value": "0-25%", "name": "0-25%" },
  { "value": "26-50%", "name": "26-50%" },
  { "value": "51-75%", "name": "51-75%" },
  { "value": "76-100%", "name": "76-100%" }
];

export const clutchTypeList = [
  { "value": "Single", "name": "Single" },
  { "value": "Dual", "name": "Dual" }
];

export const wheelDrive = [
  { "value": "2 wheel", "name": "2 wheel" },
  { "value": "4 wheel", "name": "4 wheel" }
];

export const typeOfReaper = [
  { "value": "Self propelled", "name": "Self propelled" },
  { "value": "Tractor mounted", "name": "Tractor mounted" }
];

export const cropsList = [
  { value: "MUSTARD", name: "MUSTARD" },
  { value: "SUNFLOWER", name: "SUNFLOWER" },
  { value: "OIL SEEDS", name: "OIL SEEDS" },
  { value: "SUGARCANE", name: "SUGARCANE" },
  { value: "JOWAR", name: "JOWAR" },
  { value: "BAJRA", name: "BAJRA" },
  { value: "GRAM", name: "GRAM" },
  { value: "CHILI", name: "CHILI" },
  { value: "GROUNDNUT", name: "GROUNDNUT" },
  { value: "SPICES", name: "SPICES" },
  { value: "FLORICULTURE", name: "FLORICULTURE" },
  { value: "MEDICINAL/AROMATIC PLANTS", name: "MEDICINAL/AROMATIC PLANTS" },
  { value: "BETEL VINE", name: "BETEL VINE" },
  { value: "MUSHROOM", name: "MUSHROOM" },
  { value: "HONEY", name: "HONEY" },
  { value: "JUTE", name: "JUTE" },
  { value: "TUR", name: "TUR" },
  { value: "DATES", name: "DATES" },
  { value: "SOYBEAN", name: "SOYBEAN" },
  { value: "NIGER", name: "NIGER" },
  { value: "RAGI", name: "RAGI" },
  { value: "REDGRAM", name: "REDGRAM" },
  { value: "WALNUTS", name: "WALNUTS" },
  { value: "TEA", "name": "TEA" },
  { value: "COFFEE", name: "COFFEE" },
  { value: "SILK COCOONS", name: "SILK COCOONS" },
  { value: "RUBBER", name: "RUBBER" }
];


export const ConsultationOf = [
  // {"value": "horse_dog_trainer.consultation.Breeding", "name": "Breeding"},
  // {"value": "horse_dog_trainer.consultation.Artificial.Insemination","name": "Artificial Insemination"},
  // {"value": "horse_dog_trainer.consultation.Day.care", "name": "Day care"},
  // {"value": "horse_dog_trainer.consultation.Daily.care.tip", "name": "Daily care tip"}

  { "value": "Breeding", "label": "Breeding" },
  { "value": "Artificial.Insemination", "label": "Artificial Insemination" },
  { "value": "Day care", "label": "Day care" },
  { "value": "Daily care tip", "label": "Daily care tip" }
];

export const TwineNet = [
  { "value": "Twine", "displayCode": "label.twine" },
  { "value": "Net", "displayCode": "label.net" },
  { "value": "Twine/Net", "displayCode": "label.twine_net" }
];

export const actersHr = [
  { "value": "acres/hr", "displayCode": "acres/hr" },
  { "value": "tons/hr", "displayCode": "tons/hr" },
  { "value": "bales/hr", "displayCode": "bales/hr" }
];

export const actersRepaerHr = [
  { "value": "acres/hr", "displayCode": "acres/hr" },
  { "value": "tons/hr", "displayCode": "tons/hr" },
  { "value": "trolleys/hr", "displayCode": "trolleys/hr" }
];


const languageMap = {
  "English": 'en',
  "Punjabi": 'pa',
  "Hindi": 'hi',
  "Kannada": 'kn',
  "Telugu": 'te',
  "Tamil": 'ta',
  "Asami": 'as',
  "Bangla": 'bn',
  "Gujarati": 'gu',
  "Marathi": "mr",
  "Odiya": "or"

};

export const languageCode = (lang) => {
  return languageMap[lang] || 'en';
}

export const isProdEnv = () => {
  return APP_ENV === 'prod';
}
